var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"w-full text-white font-weight-600 border-radius-8",class:{
      'min-h-48 h-48 max-h-48': _vm.isWidthLessThan360,
      'min-h-56 h-56 max-h-56': !_vm.isWidthLessThan360,
    },attrs:{"color":"cup500","loading":_vm.loading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"d-flex justify-center"},[(_vm.error)?_c('p',{staticClass:"text-red font-medium font-14"},[_vm._v(_vm._s(_vm.formattedError))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }